import { apiClient } from '../client';

export interface AutocompletePrediction {
  placeId: string;
  name: string;
  address: string;
  description: string;
}

export interface AutocompleteResponse {
  success: boolean;
  predictions: AutocompletePrediction[];
}

export interface SubmitBarResponse {
  success: boolean;
  message: string;
  bar: {
    id: string;
    name: string;
    address: string;
  };
  alreadyExists: boolean;
}

export interface Submission {
  id: string;
  googleMapsUrl: string;
  googlePlaceId: string | null;
  status: 'approved' | 'duplicate' | 'rejected' | 'pending';
  barId: string | null;
  barName: string | null;
  barAddress: string | null;
  rejectionReason: string | null;
  createdAt: string;
}

interface SubmissionHistoryResponse {
  success: boolean;
  submissions: Submission[];
  count: number;
}

export const submissionsApi = {
  getAutocomplete: async (
    input: string,
    sessionToken: string
  ): Promise<AutocompleteResponse> => {
    const response = await apiClient.get<AutocompleteResponse>(
      '/v1/submit/autocomplete',
      {
        params: { input, sessionToken },
      }
    );
    return response.data;
  },

  submitBar: async (data: {
    placeId: string;
    barName: string;
  }): Promise<SubmitBarResponse> => {
    const response = await apiClient.post<SubmitBarResponse>(
      '/v1/submit/bar',
      data
    );
    return response.data;
  },

  getHistory: async (options?: {
    limit?: number;
    withinDays?: number;
  }): Promise<SubmissionHistoryResponse> => {
    const response = await apiClient.get<SubmissionHistoryResponse>(
      '/v1/submit/history',
      {
        params: {
          limit: options?.limit ?? 20,
          withinDays: options?.withinDays,
        },
      }
    );
    return response.data;
  },
};
